






















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import ImageTile from '@/components/Views/UI/ImageTile.vue';
import {nil} from '@/common';
import {pickBy, isEqual} from 'lodash';
import {FeathersVuexFindAll} from '@/utils';

@Component({
    components: {
        ImageTile,
    },
})
export default class ImageGrid2 extends Vue {
    public page = 1;

    @Prop({default: () => {}})
    public value!: any;

    @Prop({default: ''})
    public title!: string;

    @Prop({default: false})
    public selectable!: boolean;

    @Prop({default: false})
    public deletable!: boolean;

    @Prop({default: false})
    public removable!: boolean;

    @Prop({default: false})
    public multiple!: boolean;

    @Prop({default: 9})
    public imagesPerPage!: number;

    @Prop({default: true})
    public lightbox!: boolean;

    public lightboxOptions = {
        toolbar: {
            zoomOut: true,
            zoomIn: true,
            prev: true,
            play: true,
            next: true,
        },
        title: false,
        rotatable: false,
        scalable: false,
        movable: false,
        initialViewIndex: 0,
    };

    public imageModels = [
    ];
    public mounted() {
        this.getLightBoxImages();
    }
    public onInput(value, state) {
        const copy = Object.assign({}, this.value);
        if (!this.multiple) {
            for (const key of Object.keys(copy)) {
                copy[key] = key === value ? state : false;
            }
        } else {
            copy[value] = state;
        }
        this.$emit('input', copy);
    }
    public onRemove(image) {
        const copy = Object.assign({}, this.value);
        delete copy[image];
        this.$emit('input', copy);
    }
    public async onDelete(image) {
        const copy = Object.assign({}, this.value);
        delete copy[image];
        const i = await this.$FeathersVuex.Upload.get(image);
        await i.remove();

        /*
        const [match] = this.imageModels.filter(x=>x._id === image);
        if(nil(match)){
            console.log(`could not find ${match}`);
        } else {
            console.log(match);
            console.log('this should have been deleted!');
            await match.remove();
        }
        */
        this.$emit('input', copy);
    }
    @Watch('selectable', {immediate: true})
    public onSelectableChanged(value: boolean, oldValue: boolean) {
        this.interactionTypeOk();
    }
    @Watch('removable', {immediate: true})
    public onRemovableChanged(value: boolean, oldValue: boolean) {
        this.interactionTypeOk();
    }
    public interactionTypeOk() {
        if (this.selectable && this.removable) {
            throw Error('ImageGrid should not be both selectable and removable');
        }
    }
    public async getLightBoxImages() {
        if (this.imageKeys.length === 0) { return; }
        this.imageModels = await FeathersVuexFindAll(this.$FeathersVuex.Upload, {
            query: {
                _id: this.imageKeys,
            },
        });
    }
    public get imageKeys() {
        return Object.keys(this.value);
    }
    public get currentImages() {
        if (nil(this.value, true)) {
            return [];
        } else {
            return this.imageKeys.slice(0, this.page * this.imagesPerPage);
        }
    }
    public get showLoadMore() {
        const imageAt = this.imagesPerPage * this.page;
        return this.imageKeys.length > imageAt;
    }
    public get lightBoxEnabled() {
        // lightbox is for non-selectable/non-removable only
        return !this.selectable && !this.removable && this.lightbox;
    }
    public onTileClicked(index) {
        if (this.lightBoxEnabled) {
            this.show(index);
            return;
        }
    }
    public show(init = 0) {
        this.lightboxOptions.initialViewIndex = init;
        setTimeout(() => {
            const viewer = (this.$el.querySelector('.lightbox') as any).$viewer;
            viewer.show();
        }, 250);
    }
}
